import { PDFDownloadLink } from '@react-pdf/renderer'
import React from 'react'
import { CreateButton } from '../../../../../Components/Utils/Buttons';
import DownloadPdfCq from './DownloadPdfCq';

function PdfLinkCq({headers,data,fileName}) {
    // console.log("headerssss",headers);
  return (
    <PDFDownloadLink document={<DownloadPdfCq header={headers} data={data} />} fileName={fileName}>
    {({ blob, url, loading, error }) =>
      loading ? (
        "..."
      ) : (
        <CreateButton svg={false} label="Download as PDF" />
      )
    }
  </PDFDownloadLink>
  )
}

export default PdfLinkCq